import type { ReactNode } from 'react';

import { useNavigationContext } from './Navigation.context';

type Props = {
  children: ReactNode;
};

export const NavigationExpandedOnly = ({ children }: Props) => {
  const { isCollapsed } = useNavigationContext();

  if (isCollapsed) return;

  return children;
};
